// The still background behind the Ask HR page (not Admin). Decorative, so hidden from screen
// readers.

import image from "../assets/ask-hr-background-static-muted.png";

export function Backdrop() {
  return <div className="backdrop" aria-hidden="true" style={{ backgroundImage: `url(${image})` }} />;
}
